function containsArabic(str) {
  return /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(str);
}
function fixArabicParentheses(text) {
  try {
    if (containsArabic(text)) {
      let tmp = text.replace(/\(/g, "﴿").replace(/\)/g, "﴾"); // Arabic-friendly parentheses
      return tmp.replace(/\﴿/g, ")").replace(/\﴾/g, "("); // Arabic-friendly parentheses
    }
    return text;
  } catch (error) {
    return text;
  }
}
let bulletinfOnTwoPages = false;
const totalPtsTreshold = 18.5;
let studentCount = 1;

let bulletinColors = {
  color1: [70, 187, 239],
  color2: [64, 187, 239],
  color3: [16, 169, 229],
  color4: [67, 62, 63],
  color5: [52, 172, 215],
  color6: [224, 237, 243],
  color7: [64, 187, 239],
  color8: [225, 225, 226],
  color9: [224, 237, 243],
};
function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(img); // Resolve the promise when the image loads
    img.onerror = (err) => reject(err); // Reject if there's an error
  });
}
const componentToHex = function (c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
};
const rgbToHex = function (r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
};
const getCertificationNameByMoyenne = function (moyenne, certifs) {
  for (const cert of certifs)
    if (
      Number(moyenne) >= Number(cert.min) &&
      Number(moyenne) <= Number(cert.max)
    ) {
      return cert.name;
    }

  return "";
};
const fuseSubSubjects = (student) => ({
  ...student,
  modules: student.modules.map((m) => ({
    ...m,
    subjects: m.subjects.map((s) => {
      if (s.subSubjectMarks) delete s.subSubjectMarks;
      return s;
    }),
  })),
});

const waitLoadingImage = async function (image) {
  return new Promise((res, rej) => {
    image.onload = (t) => {
      res(t);
    };
    image.onerror = (e) => {
      rej(e);
    };
  });
};

const roundRect = function (ctx, x, y, width, height, radius, fill, stroke) {
  const cornerRadius = {
    upperLeft: 0,
    upperRight: 0,
    lowerLeft: 0,
    lowerRight: 0,
  };
  if (typeof stroke == "undefined") {
    stroke = true;
  }
  if (typeof radius === "object") {
    for (const side in radius) {
      cornerRadius[side] = radius[side];
    }
  }

  ctx.lineWidth = 1;
  ctx.strokeStyle = `rgb(${bulletinColors.color1[0]}, ${bulletinColors.color1[1]}, ${bulletinColors.color1[2]})`;

  ctx.beginPath();
  ctx.moveTo(x + cornerRadius.upperLeft, y);
  ctx.lineTo(x + width - cornerRadius.upperRight, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + cornerRadius.upperRight);
  ctx.lineTo(x + width, y + height - cornerRadius.lowerRight);
  ctx.quadraticCurveTo(
    x + width,
    y + height,
    x + width - cornerRadius.lowerRight,
    y + height
  );
  ctx.lineTo(x + cornerRadius.lowerLeft, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - cornerRadius.lowerLeft);
  ctx.lineTo(x, y + cornerRadius.upperLeft);
  ctx.quadraticCurveTo(x, y, x + cornerRadius.upperLeft, y);
  ctx.closePath();
  if (stroke) {
    ctx.stroke();
  }
  if (fill) {
    ctx.fill();
  }
};
function getLogoWidth(imgData, fixedHeight = 14) {
  if (!imgData) return fixedHeight;
  const originalWidth = imgData.width;
  const originalHeight = imgData.height;
  const aspectRatio = originalWidth / originalHeight;
  const autoWidth = fixedHeight * aspectRatio;
  return isNaN(autoWidth) || !isFinite(autoWidth) ? fixedHeight : autoWidth;
}

async function imageUrlToBase64(url) {
  try {
    if (!url) throw new Error("null URL")
    const response = await fetch(url);
    const blob = await response.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // this is the Base64 string
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    return null;
  }
}

export {
  fixArabicParentheses,
  totalPtsTreshold,
  studentCount,
  bulletinfOnTwoPages,
  bulletinColors,
  fuseSubSubjects,
  waitLoadingImage,
  getLogoWidth,
  loadImage,
  roundRect,
  rgbToHex,
  getCertificationNameByMoyenne,
  imageUrlToBase64
};
